
export const EMAIL_ENDPOINT_URL = "https://stage-api.coneeds.se/email";
export const S3_URL = "https://s3.eu-central-1.amazonaws.com/mittklimatlofte.images/";